import React, { useEffect } from 'react'
import { chiliPiper } from 'Features/ScheduleCallModal/ScheduleCallModal.model'
import { useFrontEndEventTrackingService } from '@clickcease/cc-client-components-lib'

declare global {
  interface HubspotWindow extends Window {
    hbspt: {
      forms: {
        create: (options: any) => void
      }
    }
  }
}

interface FormValues {
  submissionValues: {
    firstname: string
    lastname: string
    email: string
  }
}
interface Lead {
  firstname: string
  lastname: string
  email: string
}

interface Props {
  setShowTitle: (show: boolean) => void
}

const HubSpotForm = ({ setShowTitle }: Props) => {
  const { track } = useFrontEndEventTrackingService()

  const showChilipiperCalendar = (lead: Lead) => {
    chiliPiper.submit('cheq-ai', 'Essentials_router', { lead })
    track(['dataLayer'], 'formSubmission', { uniqueId: 'chillipiper1' })
  }

  useEffect(() => {
    const script = document.createElement('script')
    script.src = 'https://js.hsforms.net/forms/v2.js'
    script.async = true
    document.body.appendChild(script)

    script.onload = () => {
      const myWindow: HubspotWindow = window as unknown as HubspotWindow

      if (myWindow.hbspt) {
        myWindow.hbspt.forms.create({
          region: 'na1',
          portalId: '5228455',
          formId: '7012e1cf-312a-4830-9791-1e795810a95e',
          target: '.hubspot_form',
          onFormSubmitted: ($form: HTMLElement, data: FormValues) => {
            const lead: Lead = {
              firstname: data.submissionValues.firstname,
              lastname: data.submissionValues.lastname,
              email: data.submissionValues.email,
            }

            setTimeout(() => {
              setShowTitle(false)
              showChilipiperCalendar(lead)
            }, 450)
          },
        })
      }
    }

    return () => {
      document.body.removeChild(script)
    }
  })

  return <div className="hubspot_form"></div>
}

export default HubSpotForm
